export function swCapitalize(sharedModule) {
  /**
   * Directive that capitalize all the input.
   */
  sharedModule.directive('swCapitalize', (uppercaseFilter) => ({
    restrict: 'A',
    require: '?ngModel',
    link: function postLink(scope, element, attrs, ctrl) {
      ctrl.$formatters.push((modelValue) => {
        return uppercaseFilter(modelValue);
      });

      ctrl.$parsers.push((viewValue) => {
        return uppercaseFilter(viewValue);
      });

      element.on('blur', () => {
        ctrl.$setViewValue(uppercaseFilter(ctrl.$modelValue));
        ctrl.$render();
      });
    },
  }));
}
